<template>
  <ion-content id="app" class="ion-padding">

    <ion-list>
      <ion-item v-for="config in allConfigs" :key="config.id"  :href="['/#/config/edit/' + config.id + '/']">
        <ion-label>{{ config.title }}</ion-label>
        <a :href="['/#/config/edit/' + config.id + '/']">
          <ion-icon name="build"></ion-icon>
        </a>
      </ion-item>
    </ion-list>

  </ion-content>
</template>

<script>

  import {mapActions, mapGetters} from "vuex";


  export default {
    name: "ConfigList",
    data(){
      return {
      }
    },
    methods: {
      ...mapActions([ "getConfigs" ]),
    },
    computed: mapGetters(["allConfigs"]),
    created() {
      this.getConfigs();
      console.log(this.allConfigs);
    }
  };
</script>

<style scoped>
  ion-list {
    --background: #3E4143;
    padding: 0;
    margin-top: 40px;
  }

  ion-icon {
    margin-left: 20px;
  }
</style>
